import React from 'react'

const Line = props => (
  <div className={`w1 absolute left-0 ${props.isOpaque ? 'bg-black' : 'bg-white'}`}
    style={Object.assign({
      height: '1px',
    }, props.style)}
  />
)

export default props => (
  <div className='relative w2 pointer'
    onClick={props.onClick}
    style={{
      height: '24px',
    }}
  >
    <Line isOpaque={props.isOpaque}
      style={{
        top: '6px',
      }}
    />
    <Line isOpaque={props.isOpaque}
      style={{
        top: '11px',
      }}
    />
    <Line isOpaque={props.isOpaque}
      style={{
        top: '16px',
      }}
    />
  </div>
)
